import { Undo2 } from 'lucide-react'
import type { EInvoiceDraftItem } from '@/lib/api/einvoice-api'
import { Button } from '@/components/ui/button'
import { TableCell, TableRow } from '@/components/ui/table'
import { m } from '@/lib/paraglide/messages'

// Placeholder row for a line the user removed in the draft editor; the line
// only leaves the invoice when the draft is saved, so it can still be restored.
export function EInvoiceDraftRemovedLine({
    item,
    onRestore,
}: {
    item: EInvoiceDraftItem
    onRestore: () => void
}) {
    return (
        <TableRow className="bg-muted/40 hover:bg-muted/40">
            <TableCell className="text-muted-foreground tabular-nums">
                {item.line_number}
            </TableCell>
            {/* One wide cell keeps the undo button from widening the narrow
                action column of the editable rows. */}
            <TableCell colSpan={7} className="whitespace-normal">
                <div className="flex flex-wrap items-center justify-between gap-2">
                    <p className="min-w-0 text-muted-foreground">
                        <span className="line-through decoration-muted-foreground/60">
                            {item.item_name}
                        </span>{' '}
                        · {m.einvoice_draft_removed_line()}
                    </p>
                    <Button
                        type="button"
                        variant="outline"
                        size="sm"
                        aria-label={m.einvoice_draft_restore_line_label({
                            line: item.line_number,
                        })}
                        onClick={onRestore}
                    >
                        <Undo2 aria-hidden="true" />
                        {m.einvoice_draft_restore_line()}
                    </Button>
                </div>
            </TableCell>
        </TableRow>
    )
}
